import { useState, useEffect, useCallback } from 'react';

import { buildArray } from 'utilities';

async function noOperation() {

}

export function useForm(values, onChangeCallback, validator = noOperation, exceptionToErrorMessages) {

  const [fieldValues, setFieldValues] = useState([...values]);
  const [modifiedState, setModifiedState] = useState(buildDefaultModifiedState(values));
  const [errorMessages, _setErrorMessages] = useState(buildDefaultErrorMessages(values));

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const validateFunction = useCallback(validate, [fieldValues]);

  const convertExceptionToErrorMessages = getExceptionToErrorMessagesConverter();

  useEffect(function onFieldsChange() {

    const timerReference = setTimeout(function timerCallback() {
      validateFunction();
    }, 200);

    return function cleanup() {
      clearTimeout(timerReference);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fieldValues]);

  useEffect(function onFieldsChange() {

    onChangeCallback(fieldValues);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [validateFunction]);

  function getExceptionToErrorMessagesConverter() {

    if (typeof exceptionToErrorMessages === 'function') {
      return exceptionToErrorMessages;
    }

    return defaultExceptionToErrorMessagesConvertor;

  }

  function defaultExceptionToErrorMessagesConvertor() {
    return buildArray(values.length, '');
  }

  function setErrorMessages(_errorMessages, forceSet = false) {

    const _errorMessagesLength = _errorMessages.length;

    for (let index = 0; index < _errorMessagesLength; index++) {

      if (forceSet === true) {
        continue;
      }

      if (modifiedState[index] === true) {
        continue;
      }

      _errorMessages[index] = '';

    }

    _setErrorMessages(_errorMessages);

  }

  async function validate() {

    try {

      await validator(fieldValues);

      const errorMessages = convertExceptionToErrorMessages({ metadata: [] });

      setErrorMessages(errorMessages);

    } catch (exception) {

      if (exception.code !== 'ValidationError') {
        throw exception;
      }

      const errorMessages = convertExceptionToErrorMessages(exception);

      setErrorMessages(errorMessages);

    }

  }

  function setModifiedStateByIndex(fieldIndex, modifiedState) {

    setModifiedState(function updateModifiedState(modifiedStates) {

      modifiedStates[fieldIndex] = modifiedState;

      return [...modifiedStates];

    });

  }

  function setValueByIndex(fieldIndex, value, throughUser = true) {

    setModifiedStateByIndex(fieldIndex, throughUser);

    setFieldValues(function updateFieldValues(fieldValues) {

      fieldValues[fieldIndex] = value;

      return [...fieldValues];

    });

  }

  function buildDefaultModifiedState(values) {

    const array = [];
    const valuesLength = values.length;

    for (let index = 0; index < valuesLength; index++) {

      array.push(false);

    }

    return array;

  }

  function buildDefaultErrorMessages(values) {

    const array = [];

    const valuesLength = values.length;

    for (let index = 0; index < valuesLength; index++) {

      array.push('');

    }

    return array;

  }

  function addFields(values) {

    const _modifiedState = buildDefaultModifiedState(values);
    const _errorMessages = buildDefaultErrorMessages(values);

    setFieldValues([...fieldValues, ...values]);
    setModifiedState([...modifiedState, ..._modifiedState]);
    _setErrorMessages([...errorMessages, ..._errorMessages]);

  }

  return [fieldValues, setValueByIndex, errorMessages, setErrorMessages, addFields, [...modifiedState], setModifiedStateByIndex];

}